const Copy = ({ color, type }) => {
  const solid = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7919 17.4959C17.0262 17.4959 16.3085 17.2014 15.7664 16.6593L12.8465 13.7394C12.6458 13.5387 12.2815 13.5387 12.0808 13.7394L9.14888 16.6713C8.60678 17.2134 7.88908 17.5079 7.12339 17.5079H6.54639L10.256 21.2175C11.41 22.3715 13.2937 22.3715 14.4477 21.2175L18.1682 17.497L17.7919 17.4959Z"
        fill={color}
      />
      <path
        d="M7.11121 7.157C7.87691 7.157 8.59461 7.4515 9.13671 7.99359L12.0686 10.9255C12.2802 11.1371 12.6216 11.1371 12.8343 10.9255L15.7662 8.00559C16.3083 7.4635 17.026 7.169 17.7917 7.169H18.1451L14.4246 3.44851C13.2706 2.29451 11.3869 2.29451 10.2329 3.44851L6.52222 7.157H7.11121Z"
        fill={color}
      />
      <path
        d="M21.2175 10.2428L18.9684 7.99369C18.9215 8.01768 18.8626 8.02859 18.8037 8.02859H17.7795C17.2494 8.02859 16.7314 8.24019 16.367 8.61759L13.4461 11.5375C13.1756 11.808 12.8102 11.9498 12.4568 11.9498C12.0914 11.9498 11.738 11.808 11.4675 11.5375L8.53558 8.60559C8.15927 8.22929 7.64117 8.01659 7.12307 8.01659H5.86328C5.80438 8.01659 5.75748 8.00459 5.71057 7.98169L3.44948 10.2428C2.29549 11.3968 2.29549 13.2805 3.44948 14.4345L5.69858 16.6836C5.74548 16.6596 5.79238 16.6487 5.85128 16.6487H7.11108C7.64117 16.6487 8.15927 16.4371 8.52358 16.0597L11.4555 13.1278C11.9856 12.5977 12.916 12.5977 13.445 13.1278L16.3649 16.0477C16.7412 16.424 17.2593 16.6367 17.7774 16.6367H18.8016C18.8605 16.6367 18.9074 16.6487 18.9663 16.6716L21.2154 14.4225C22.3715 13.2685 22.3715 11.3968 21.2175 10.2428Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      default:
        return solid;
    }
  };

  return getSVGByType(type);
};

export default Copy;
